import { DrawerMenuItemList } from 'Components/Layout/DrawerMenu/DrawerMenuItemList'
import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import StyledDrawer from 'Components/StyledDrawer'
import { isPtaBannerVisible } from 'Services/common/Features/Authority/Context/utils'
import useTypedSelector from 'Store'
import { useLocation } from 'react-router-dom'

interface DrawerMenuProps {
  drawerMenuNavLinks: NavLinkItem[]
  rootUrl: string
}

function DrawerMenu({ drawerMenuNavLinks, rootUrl }: Readonly<DrawerMenuProps>) {
  const location = useLocation()
  const { user } = useTypedSelector(state => state.user)
  return (
    <StyledDrawer
      isPtaBannerVisible={isPtaBannerVisible(user, location)}
      variant="permanent"
      open={true}
    >
      <DrawerMenuItemList navLinks={drawerMenuNavLinks} rootUrl={rootUrl} />
    </StyledDrawer>
  )
}

export { DrawerMenu }
